import React from 'react';
import { ParallaxSection } from './ParallaxSection';
interface InfoSectionProps {
  title: string;
  description: string;
  align?: 'left' | 'center';
  highlight?: boolean;
}
export function InfoSection({
  title,
  description,
  align = 'left',
  highlight = false
}: InfoSectionProps) {
  return <section className={`h-[1024px] px-4 flex items-center justify-center overflow-hidden ${highlight ? 'bg-white/5' : ''}`} data-id="element-92">
      <ParallaxSection speed={0.3} data-id="element-93">
        <div className={`max-w-4xl ${align === 'center' ? 'mx-auto text-center' : ''}`} data-id="element-94">
          <h2 className="text-3xl md:text-5xl font-bold mb-6 leading-tight max-w-[280px] md:max-w-[850px] text-left" data-id="element-95">
            {title}
          </h2>
          <p className="text-xl md:text-2xl text-white/80 leading-relaxed text-left max-w-[280px] md:max-w-[800px]" data-id="element-96">
            {description}
          </p>
        </div>
      </ParallaxSection>
    </section>;
}